"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8329],{

/***/ 68329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useForm; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(46528);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/filter-errors/filter-errors.js
function filterErrors(errors) {
  if (errors === null || typeof errors !== "object") {
    return {};
  }
  return Object.keys(errors).reduce((acc, key) => {
    const errorValue = errors[key];
    if (errorValue !== void 0 && errorValue !== null && errorValue !== false) {
      acc[key] = errorValue;
    }
    return acc;
  }, {});
}


//# sourceMappingURL=filter-errors.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/lists/clear-list-state.js
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function clearListState(field, state) {
  if (state === null || typeof state !== "object") {
    return {};
  }
  const clone = __spreadValues({}, state);
  Object.keys(state).forEach((errorKey) => {
    if (errorKey.includes(`${String(field)}.`)) {
      delete clone[errorKey];
    }
  });
  return clone;
}


//# sourceMappingURL=clear-list-state.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/form-index.js
const FORM_INDEX = "__MANTINE_FORM_INDEX__";


//# sourceMappingURL=form-index.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/validate/should-validate-on-change.js


function shouldValidateOnChange(path, validateInputOnChange) {
  if (!validateInputOnChange) {
    return false;
  }
  if (typeof validateInputOnChange === "boolean") {
    return validateInputOnChange;
  }
  if (Array.isArray(validateInputOnChange)) {
    return validateInputOnChange.includes(path.replace(/[.][0-9]/g, `.${FORM_INDEX}`));
  }
  return false;
}


//# sourceMappingURL=should-validate-on-change.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/klona@2.0.6/node_modules/klona/full/index.mjs
function set(obj, key, val) {
	if (typeof val.value === 'object') val.value = klona(val.value);
	if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === '__proto__') {
		Object.defineProperty(obj, key, val);
	} else obj[key] = val.value;
}

function klona(x) {
	if (typeof x !== 'object') return x;

	var i=0, k, list, tmp, str=Object.prototype.toString.call(x);

	if (str === '[object Object]') {
		tmp = Object.create(x.__proto__ || null);
	} else if (str === '[object Array]') {
		tmp = Array(x.length);
	} else if (str === '[object Set]') {
		tmp = new Set;
		x.forEach(function (val) {
			tmp.add(klona(val));
		});
	} else if (str === '[object Map]') {
		tmp = new Map;
		x.forEach(function (val, key) {
			tmp.set(klona(key), klona(val));
		});
	} else if (str === '[object Date]') {
		tmp = new Date(+x);
	} else if (str === '[object RegExp]') {
		tmp = new RegExp(x.source, x.flags);
	} else if (str === '[object DataView]') {
		tmp = new x.constructor( klona(x.buffer) );
	} else if (str === '[object ArrayBuffer]') {
		tmp = x.slice(0);
	} else if (str.slice(-6) === 'Array]') {
		// ArrayBuffer.isView(x)
		// ~> `new` bcuz `Buffer.slice` => ref
		tmp = new x.constructor(x);
	}

	if (tmp) {
		for (list=Object.getOwnPropertySymbols(x); i < list.length; i++) {
			set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
		}

		for (i=0, list=Object.getOwnPropertyNames(x); i < list.length; i++) {
			if (Object.hasOwnProperty.call(tmp, k=list[i]) && tmp[k] === x[k]) continue;
			set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
		}
	}

	return tmp || x;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/get-splitted-path.js
function getSplittedPath(path) {
  if (typeof path !== "string") {
    return [];
  }
  return path.split(".");
}


//# sourceMappingURL=get-splitted-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/set-path.js



function setPath(path, value, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0) {
    return values;
  }
  const cloned = klona(values);
  if (splittedPath.length === 1) {
    cloned[splittedPath[0]] = value;
    return cloned;
  }
  let val = cloned[splittedPath[0]];
  for (let i = 1; i < splittedPath.length - 1; i += 1) {
    if (val === void 0) {
      return cloned;
    }
    val = val[splittedPath[i]];
  }
  val[splittedPath[splittedPath.length - 1]] = value;
  return cloned;
}


//# sourceMappingURL=set-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/get-path.js


function getPath(path, values) {
  const splittedPath = getSplittedPath(path);
  if (splittedPath.length === 0 || typeof values !== "object" || values === null) {
    return void 0;
  }
  let value = values[splittedPath[0]];
  for (let i = 1; i < splittedPath.length; i += 1) {
    if (value === void 0) {
      break;
    }
    value = value[splittedPath[i]];
  }
  return value;
}


//# sourceMappingURL=get-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/validate/validate-values.js



function getValidationResults(errors) {
  const filteredErrors = filterErrors(errors);
  return { hasErrors: Object.keys(filteredErrors).length > 0, errors: filteredErrors };
}
function validateRulesRecord(rules, values, path = "", errors = {}) {
  if (typeof rules !== "object" || rules === null) {
    return errors;
  }
  return Object.keys(rules).reduce((acc, ruleKey) => {
    const rule = rules[ruleKey];
    const rulePath = `${path === "" ? "" : `${path}.`}${ruleKey}`;
    const value = getPath(rulePath, values);
    let arrayValidation = false;
    if (typeof rule === "function") {
      acc[rulePath] = rule(value, values, rulePath);
    }
    if (typeof rule === "object" && Array.isArray(value)) {
      arrayValidation = true;
      value.forEach((_item, index) => validateRulesRecord(rule, values, `${rulePath}.${index}`, acc));
    }
    if (typeof rule === "object" && typeof value === "object" && value !== null) {
      if (!arrayValidation) {
        validateRulesRecord(rule, values, rulePath, acc);
      }
    }
    return acc;
  }, errors);
}
function validateValues(validate, values) {
  if (typeof validate === "function") {
    return getValidationResults(validate(values));
  }
  return getValidationResults(validateRulesRecord(validate, values));
}


//# sourceMappingURL=validate-values.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/validate/validate-field-value.js


function validateFieldValue(path, rules, values) {
  if (typeof path !== "string") {
    return { hasError: false, error: null };
  }
  const results = validateValues(rules, values);
  const pathInError = Object.keys(results.errors).find((errorKey) => path.split(".").every((pathPart, i) => pathPart === errorKey.split(".")[i]));
  return { hasError: !!pathInError, error: pathInError ? results.errors[pathInError] : null };
}


//# sourceMappingURL=validate-field-value.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/reorder-path.js



function reorderPath(path, { from, to }, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  const item = currentValue[from];
  cloned.splice(from, 1);
  cloned.splice(to, 0, item);
  return setPath(path, cloned, values);
}


//# sourceMappingURL=reorder-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/lists/reorder-errors.js
var reorder_errors_defProp = Object.defineProperty;
var reorder_errors_getOwnPropSymbols = Object.getOwnPropertySymbols;
var reorder_errors_hasOwnProp = Object.prototype.hasOwnProperty;
var reorder_errors_propIsEnum = Object.prototype.propertyIsEnumerable;
var reorder_errors_defNormalProp = (obj, key, value) => key in obj ? reorder_errors_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var reorder_errors_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (reorder_errors_hasOwnProp.call(b, prop))
      reorder_errors_defNormalProp(a, prop, b[prop]);
  if (reorder_errors_getOwnPropSymbols)
    for (var prop of reorder_errors_getOwnPropSymbols(b)) {
      if (reorder_errors_propIsEnum.call(b, prop))
        reorder_errors_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function reorderErrors(path, { from, to }, errors) {
  const oldKeyStart = `${path}.${from}`;
  const newKeyStart = `${path}.${to}`;
  const clone = reorder_errors_spreadValues({}, errors);
  Object.keys(errors).every((key) => {
    let oldKey;
    let newKey;
    if (key.startsWith(oldKeyStart)) {
      oldKey = key;
      newKey = key.replace(oldKeyStart, newKeyStart);
    }
    if (key.startsWith(newKeyStart)) {
      oldKey = key.replace(newKeyStart, oldKeyStart);
      newKey = key;
    }
    if (oldKey && newKey) {
      const value1 = clone[oldKey];
      const value2 = clone[newKey];
      value2 === void 0 ? delete clone[oldKey] : clone[oldKey] = value2;
      value1 === void 0 ? delete clone[newKey] : clone[newKey] = value1;
      return false;
    }
    return true;
  });
  return clone;
}


//# sourceMappingURL=reorder-errors.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/remove-path.js



function removePath(path, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  return setPath(path, currentValue.filter((_, itemIndex) => itemIndex !== index), values);
}


//# sourceMappingURL=remove-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/lists/change-error-indices.js


var change_error_indices_defProp = Object.defineProperty;
var change_error_indices_getOwnPropSymbols = Object.getOwnPropertySymbols;
var change_error_indices_hasOwnProp = Object.prototype.hasOwnProperty;
var change_error_indices_propIsEnum = Object.prototype.propertyIsEnumerable;
var change_error_indices_defNormalProp = (obj, key, value) => key in obj ? change_error_indices_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var change_error_indices_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (change_error_indices_hasOwnProp.call(b, prop))
      change_error_indices_defNormalProp(a, prop, b[prop]);
  if (change_error_indices_getOwnPropSymbols)
    for (var prop of change_error_indices_getOwnPropSymbols(b)) {
      if (change_error_indices_propIsEnum.call(b, prop))
        change_error_indices_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function getIndexFromKeyAfterPath(key, path) {
  const split = key.substring(path.length + 1).split(".")[0];
  return parseInt(split, 10);
}
function changeErrorIndices(path, index, errors, change) {
  if (index === void 0) {
    return errors;
  }
  const pathString = `${String(path)}`;
  let clearedErrors = errors;
  if (change === -1) {
    clearedErrors = clearListState(`${pathString}.${index}`, clearedErrors);
  }
  const cloned = change_error_indices_spreadValues({}, clearedErrors);
  const changedKeys = new Set();
  Object.entries(clearedErrors).filter(([key]) => {
    if (!key.startsWith(`${pathString}.`)) {
      return false;
    }
    const currIndex = getIndexFromKeyAfterPath(key, pathString);
    if (Number.isNaN(currIndex)) {
      return false;
    }
    return currIndex >= index;
  }).forEach(([key, value]) => {
    const currIndex = getIndexFromKeyAfterPath(key, pathString);
    const newKey = key.replace(`${pathString}.${currIndex}`, `${pathString}.${currIndex + change}`);
    cloned[newKey] = value;
    changedKeys.add(newKey);
    if (!changedKeys.has(key)) {
      delete cloned[key];
    }
  });
  return cloned;
}


//# sourceMappingURL=change-error-indices.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/paths/insert-path.js



function insertPath(path, value, index, values) {
  const currentValue = getPath(path, values);
  if (!Array.isArray(currentValue)) {
    return values;
  }
  const cloned = [...currentValue];
  cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
  return setPath(path, cloned, values);
}


//# sourceMappingURL=insert-path.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/get-status/get-status.js
function getStatus(status, path) {
  const paths = Object.keys(status);
  if (typeof path === "string") {
    const nestedPaths = paths.filter((statusPath) => statusPath.startsWith(`${path}.`));
    return status[path] || nestedPaths.some((statusPath) => status[statusPath]) || false;
  }
  return paths.some((statusPath) => status[statusPath]);
}


//# sourceMappingURL=get-status.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/get-input-on-change/get-input-on-change.js
function getInputOnChange(setValue) {
  return (val) => {
    if (!val) {
      setValue(val);
    } else if (typeof val === "function") {
      setValue(val);
    } else if (typeof val === "object" && "nativeEvent" in val) {
      const { currentTarget } = val;
      if (currentTarget instanceof HTMLInputElement) {
        if (currentTarget.type === "checkbox") {
          setValue(currentTarget.checked);
        } else {
          setValue(currentTarget.value);
        }
      } else if (currentTarget instanceof HTMLTextAreaElement || currentTarget instanceof HTMLSelectElement) {
        setValue(currentTarget.value);
      }
    } else {
      setValue(val);
    }
  };
}


//# sourceMappingURL=get-input-on-change.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/use-form.js

















var use_form_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var use_form_getOwnPropSymbols = Object.getOwnPropertySymbols;
var use_form_hasOwnProp = Object.prototype.hasOwnProperty;
var use_form_propIsEnum = Object.prototype.propertyIsEnumerable;
var use_form_defNormalProp = (obj, key, value) => key in obj ? use_form_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var use_form_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (use_form_hasOwnProp.call(b, prop))
      use_form_defNormalProp(a, prop, b[prop]);
  if (use_form_getOwnPropSymbols)
    for (var prop of use_form_getOwnPropSymbols(b)) {
      if (use_form_propIsEnum.call(b, prop))
        use_form_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function useForm({
  initialValues = {},
  initialErrors = {},
  initialDirty = {},
  initialTouched = {},
  clearInputErrorOnChange = true,
  validateInputOnChange = false,
  validateInputOnBlur = false,
  transformValues = (values) => values,
  validate: rules
} = {}) {
  const [touched, setTouched] = (0,react.useState)(initialTouched);
  const [dirty, setDirty] = (0,react.useState)(initialDirty);
  const [values, _setValues] = (0,react.useState)(initialValues);
  const [errors, _setErrors] = (0,react.useState)(filterErrors(initialErrors));
  const valuesSnapshot = (0,react.useRef)(initialValues);
  const setValuesSnapshot = (_values) => {
    valuesSnapshot.current = _values;
  };
  const resetTouched = (0,react.useCallback)(() => setTouched({}), []);
  const resetDirty = (_values) => {
    const newSnapshot = _values ? use_form_spreadValues(use_form_spreadValues({}, values), _values) : values;
    setValuesSnapshot(newSnapshot);
    setDirty({});
  };
  const setErrors = (0,react.useCallback)((errs) => _setErrors((current) => filterErrors(typeof errs === "function" ? errs(current) : errs)), []);
  const clearErrors = (0,react.useCallback)(() => _setErrors({}), []);
  const reset = (0,react.useCallback)(() => {
    _setValues(initialValues);
    clearErrors();
    setValuesSnapshot(initialValues);
    setDirty({});
    resetTouched();
  }, []);
  const setFieldError = (0,react.useCallback)((path, error) => setErrors((current) => __spreadProps(use_form_spreadValues({}, current), { [path]: error })), []);
  const clearFieldError = (0,react.useCallback)((path) => setErrors((current) => {
    if (typeof path !== "string") {
      return current;
    }
    const clone = use_form_spreadValues({}, current);
    delete clone[path];
    return clone;
  }), []);
  const clearFieldDirty = (0,react.useCallback)((path) => setDirty((current) => {
    if (typeof path !== "string") {
      return current;
    }
    const result = clearListState(path, current);
    delete result[path];
    return result;
  }), []);
  const setFieldValue = (0,react.useCallback)((path, value) => {
    const shouldValidate = shouldValidateOnChange(path, validateInputOnChange);
    clearFieldDirty(path);
    setTouched((currentTouched) => __spreadProps(use_form_spreadValues({}, currentTouched), { [path]: true }));
    _setValues((current) => {
      const result = setPath(path, value, current);
      if (shouldValidate) {
        const validationResults = validateFieldValue(path, rules, result);
        validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
      }
      return result;
    });
    !shouldValidate && clearInputErrorOnChange && setFieldError(path, null);
  }, []);
  const setValues = (0,react.useCallback)((payload) => {
    _setValues((currentValues) => {
      const valuesPartial = typeof payload === "function" ? payload(currentValues) : payload;
      return use_form_spreadValues(use_form_spreadValues({}, currentValues), valuesPartial);
    });
    clearInputErrorOnChange && clearErrors();
  }, []);
  const reorderListItem = (0,react.useCallback)((path, payload) => {
    clearFieldDirty(path);
    _setValues((current) => reorderPath(path, payload, current));
    _setErrors((errs) => reorderErrors(path, payload, errs));
  }, []);
  const removeListItem = (0,react.useCallback)((path, index) => {
    clearFieldDirty(path);
    _setValues((current) => removePath(path, index, current));
    _setErrors((errs) => changeErrorIndices(path, index, errs, -1));
  }, []);
  const insertListItem = (0,react.useCallback)((path, item, index) => {
    clearFieldDirty(path);
    _setValues((current) => insertPath(path, item, index, current));
    _setErrors((errs) => changeErrorIndices(path, index, errs, 1));
  }, []);
  const validate = (0,react.useCallback)(() => {
    const results = validateValues(rules, values);
    _setErrors(results.errors);
    return results;
  }, [values, rules]);
  const validateField = (0,react.useCallback)((path) => {
    const results = validateFieldValue(path, rules, values);
    results.hasError ? setFieldError(path, results.error) : clearFieldError(path);
    return results;
  }, [values, rules]);
  const getInputProps = (path, { type = "input", withError = true, withFocus = true } = {}) => {
    const onChange = getInputOnChange((value) => setFieldValue(path, value));
    const payload = { onChange };
    if (withError) {
      payload.error = errors[path];
    }
    if (type === "checkbox") {
      payload.checked = getPath(path, values);
    } else {
      payload.value = getPath(path, values);
    }
    if (withFocus) {
      payload.onFocus = () => setTouched((current) => __spreadProps(use_form_spreadValues({}, current), { [path]: true }));
      payload.onBlur = () => {
        if (shouldValidateOnChange(path, validateInputOnBlur)) {
          const validationResults = validateFieldValue(path, rules, values);
          validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
        }
      };
    }
    return payload;
  };
  const onSubmit = (handleSubmit, handleValidationFailure) => (event) => {
    event == null ? void 0 : event.preventDefault();
    const results = validate();
    if (results.hasErrors) {
      handleValidationFailure == null ? void 0 : handleValidationFailure(results.errors, values, event);
    } else {
      handleSubmit == null ? void 0 : handleSubmit(transformValues(values), event);
    }
  };
  const getTransformedValues = (input) => transformValues(input || values);
  const onReset = (0,react.useCallback)((event) => {
    event.preventDefault();
    reset();
  }, []);
  const isDirty = (path) => {
    if (path) {
      const overriddenValue = getPath(path, dirty);
      if (typeof overriddenValue === "boolean") {
        return overriddenValue;
      }
      const sliceOfValues = getPath(path, values);
      const sliceOfInitialValues = getPath(path, valuesSnapshot.current);
      return !fast_deep_equal_default()(sliceOfValues, sliceOfInitialValues);
    }
    const isOverridden = Object.keys(dirty).length > 0;
    if (isOverridden) {
      return getStatus(dirty);
    }
    return !fast_deep_equal_default()(values, valuesSnapshot.current);
  };
  const isTouched = (0,react.useCallback)((path) => getStatus(touched, path), [touched]);
  const isValid = (0,react.useCallback)((path) => path ? !validateFieldValue(path, rules, values).hasError : !validateValues(rules, values).hasErrors, [values, rules]);
  return {
    values,
    errors,
    setValues,
    setErrors,
    setFieldValue,
    setFieldError,
    clearFieldError,
    clearErrors,
    reset,
    validate,
    validateField,
    reorderListItem,
    removeListItem,
    insertListItem,
    getInputProps,
    onSubmit,
    onReset,
    isDirty,
    isTouched,
    setTouched,
    setDirty,
    resetTouched,
    resetDirty,
    isValid,
    getTransformedValues
  };
}


//# sourceMappingURL=use-form.js.map


/***/ }),

/***/ 46528:
/***/ (function(module) {



// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ })

}]);